export default __webpack_public_path__ + "static/media/relatedProgImg1.f9c30889.png";